






import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Mutation } from 'vuex-class';
import { getToken } from './query';

@Component({})
export default class App extends Vue {
    @Mutation public setToken: any;

    private beforeMount() {
        this.setToken(getToken());
    }
}
